import { defineStore } from "pinia";
import { removeApiKey, setApiKey } from "../providers/api-key.provider";

export const useAuthStore = defineStore("auth", () => {
  const {
    result: currentAuthenticatedUser,
    fetch: fetchCurrentUser,
    loadedOnce: fetchedState,
    loading: loginLoading,
  } = api.authentication.useCurrentUser({ immediate: true, server: false });

  const { fetch: login } = api.authentication.useLogin();

  const isAuthenticated = computed(() => {
    return !!currentAuthenticatedUser.value;
  });

  const logIn = async (email: string, password: string) => {
    const { accessToken } = await login({ email, password });
    setApiKey(accessToken);
    await fetchCurrentUser();
  };

  const logOut = () => {
    removeApiKey();
    // @ts-ignore
    currentAuthenticatedUser.value = null;
  };

  return {
    logIn,
    loginLoading,
    logOut,
    currentAuthenticatedUser,
    isAuthenticated,
    fetchedState,
    fetchCurrentUser,
  };
});
